import NoPageFound from 'pages/common/pageNotFound';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RepositoryTabs from './pages/repository';

function Repository() {
  return (
    <div>
      <Routes>
        <Route path='/*' element={<RepositoryTabs />} />

        {/* empty page when route not found */}
        <Route path='*' element={<NoPageFound />} />
      </Routes>
    </div>
  );
}

export default Repository;
